export type MapRecord = Record<string, any>;

export type OriginalMapStoreEntry = {
  fingerprint: string;
  data: MapRecord;
};

export type OriginalMapStore = {
  current?: MapRecord;
  currentIndex?: number;
  byIndex: Record<string, OriginalMapStoreEntry>;
};

const originalMapStore: OriginalMapStore = { byIndex: {} };
const originalMapSourceIds = new WeakMap<object, string>();
let nextOriginalMapSourceId = 1;

function clonePlain<T>(value: T): T | null {
  try {
    if (typeof structuredClone === "function") return structuredClone(value);
  } catch {}
  try {
    return JSON.parse(JSON.stringify(value)) as T;
  } catch {
    return null;
  }
}

function mapFingerprint(mapData: MapRecord): string {
  let sourceId = originalMapSourceIds.get(mapData);
  if (!sourceId) {
    sourceId = String(nextOriginalMapSourceId++);
    originalMapSourceIds.set(mapData, sourceId);
  }
  return sourceId;
}

export function getOriginalMapStore(): OriginalMapStore {
  return originalMapStore;
}

export function getCurrentOriginalMapData(): MapRecord | undefined {
  return originalMapStore.current;
}

export function rememberOriginalMapData(
  game: Krunker.Game,
  mapIndex: unknown,
): void {
  const numericMapIndex =
    typeof mapIndex === "number" ? mapIndex : parseInt(String(mapIndex), 10);
  if (!Number.isInteger(numericMapIndex)) return;
  const source = game.map?.maps?.[numericMapIndex] as MapRecord | undefined;
  if (!source || typeof source !== "object") return;

  const key = String(numericMapIndex);
  const fingerprint = mapFingerprint(source);
  let entry = originalMapStore.byIndex[key];
  if (!entry || entry.fingerprint !== fingerprint) {
    const snapshot = clonePlain(source);
    if (!snapshot) return;
    entry = { fingerprint, data: snapshot };
    originalMapStore.byIndex[key] = entry;
  }

  originalMapStore.current = entry.data;
  originalMapStore.currentIndex = numericMapIndex;
  localStorage.mapToEdit = JSON.stringify(entry.data);
}